import { unsafeCSS, type CSSResult } from 'lit';
import { toCSSValue } from '@loadsmart/miranda-tokens';
import type {
	BorderToken,
	ElevationToken,
	FontFamilyToken,
	FontSizeToken,
	FontWeightToken,
	GlowToken,
	LineHeightToken,
	OpacityToken,
	SpacingToken,
	GlobalToken,
} from '@loadsmart/miranda-tokens';

type NonColorToken =
	| BorderToken
	| ElevationToken
	| FontFamilyToken
	| FontSizeToken
	| FontWeightToken
	| GlowToken
	| LineHeightToken
	| OpacityToken
	| SpacingToken
	| GlobalToken;

/**
 * Get token as lit's `CSSResult`
 * @param {NonColorToken} token - Miranda token
 * @returns {CSSResult}
 */
function getToken(token: NonColorToken): CSSResult {
	return unsafeCSS(toCSSValue(token));
}

export default getToken;
